<header>
    <picture>
      <source media="(max-width: 576px)"
              srcset="/assets/images/forside_hero/landkort/landkort-mobil.png, /assets/images/forside_hero/landkort/landkort-mobil@2x.png 2x">
    
      <source media="(max-width: 991px)"
              srcset="/assets/images/forside_hero/landkort/landkort-tablet.png, /assets/images/forside_hero/landkort/landkort-tablet@2x.png 2x">
    
      <source media="(min-width: 992px)"
              srcset="/assets/images/forside_hero/landkort/Landkort_desktop.png, /assets/images/forside_hero/landkort/landkort_desktop@2x.png 2x">
    
      <img src="/assets/images/forside_hero/landkort/landkort-dtp-1920x1080px.png"
              alt="40000 vindere på DK landkort">
    </picture>
    <div class="cta mx-auto text-kl-white text-center">
        <a (click)="showPage()" class="btn btn-kl-red btn-lg mb-3 pulse">SPIL MED</a>
    </div>
  </header>